import * as React from 'react';
import {ReactComponent as Rocket} from '../assets/icon-rocket.svg';

type Props = {
    children: React.ReactNode;
};
export const Card = (props: Props) => {
    return (
        <div
            className={`
            w-full flex flex-col items-start justify-start
        `}
        >
            <div className="w-full overflow-hidden h-20 relative">
                <div className="
                    relative
                    mt-[1px]
                    h-1/2
                    bg-background
                    flex
                    justify-center
                    items-center
                    mr-20
                    rounded-t-3xl
                    border-t
                    border-r
                    border-l
                    border-border

                    before:content-['']
                    before:left-full
                    before:-bottom-full
                    before:absolute
                    before:w-10
                    before:h-24
                    before:ml-[1px]
                    before:rounded-bl-3xl
                    before:shadow-[0rem_3rem_0_0rem_auto]
                    before:shadow-background

                    after:content-['']
                    after:left-full
                    after:top-full
                    after:absolute
                    after:w-10
                    after:h-full
                    after:rounded-bl-3xl
                    after:border-border
                    after:border-l
                    after:border-b
                "/>
                <div
                    className="
                        h-1/2
                        mr-20
                        bg-background
                        border-l
                        border-border
                    "
                />
                <div className="absolute right-0 top-0 w-16 h-16 bg-background rounded-full flex items-center justify-center">
                    <Rocket className="fill-primary w-8 h-auto" />
                </div>
            </div>
            <div className="
                relative
                bg-background
                w-full
                min-h-12
                rounded-tr-3xl
                rounded-bl-3xl
                rounded-br-3xl
                border-border
                border-l
                border-b
                border-r
                pb-8

                before:content-['']
                before:absolute
                before:right-[-1px]
                before:top-[-1px]
                before:w-11
                before:h-6
                before:border-border
                before:rounded-tr-3xl
                before:border-t
                before:border-r
            ">
                <div className="w-full -mt-4 px-12 md:px-6">
                    {props.children}
                </div>
            </div>
        </div>
    );
};